import { DataForSearchTour } from 'entities/tour/models'

import { Hotel } from 'shared/api/tours/search'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const createSearchTourData = (
  hotel: Hotel,
): Partial<DataForSearchTour> => {
  const requestQuery = hotel.request_query
  const result: Partial<DataForSearchTour> = {
    is_flexible_date: false,
    is_flexible_nights: false,
  }

  if (requestQuery?.nights) {
    result.duration = requestQuery.nights
  }

  if (requestQuery?.town_from_id) {
    result.departure = {
      id: String(requestQuery.town_from_id),
      name: '',
      flag: '',
    }
  }

  if (hotel.state_name || requestQuery?.state_id) {
    result.country = {
      name: hotel.state_name,
      state_id: requestQuery?.state_id || 0,
      ...(requestQuery?.state_id && {
        id: String(requestQuery.state_id),
      }),
    }
  }

  if (requestQuery?.checkin_date) {
    result.flight = {
      startDay: dateFormat(
        requestQuery.checkin_date,
        DATE_FORMAT_LIST.YEAR_FULL_DATE,
      ),
    }
  }

  if (requestQuery?.child || requestQuery?.ages) {
    result.passengers = {
      adults: requestQuery?.adult || 0,
      ...(requestQuery?.child && { children: requestQuery.child }),
      ...(requestQuery?.ages && { childrenAges: requestQuery.ages }),
    }
  } else if (requestQuery?.adult) {
    result.passengers = {
      adults: requestQuery.adult,
    }
  }

  return result
}
